import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import { IoAddOutline, IoDocumentTextOutline, IoSearch } from 'react-icons/io5';
import { query, collection, onSnapshot, orderBy } from "firebase/firestore";
import OutletHead from '../../../components/common/outlet-head';
import { db } from '../../../firebase';
import { useAuth } from '../../../context/AuthContext';
import Datatable from '../../../components/expenses/datatable';
import { IoIosList } from "react-icons/io";
import Categories from './categories';
import AddUpdateExpense from '../../../components/expenses/form';

function Expenses() {

  const { user } = useAuth();
  const { bid } = user.claims;
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [isAdding, setIsAdding] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState(null);
  const [showExpenseModal, setShowExpenseModal] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);

  const getExpenses = () => {
    const q = query(collection(db, "Businesses", bid, "Expenses"), orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach((doc) => {
        tempData.push({ id: doc.id, ...doc.data() });
      });

      setData(tempData);
      setIsLoading(false);
    }, (error) => {
      console.log(error.message);
      setIsLoading(false);
    });

    return () => unsubscribe;
  }

  useEffect(() => {
    getExpenses();
  }, []);

  return (
    <section className='section'>
      <OutletHead
        left={
          <h5 className='mb-0 fw-600'>Expenses</h5>
        }
        right={
          <div className='d-flex align-items-center'>
            <Button
              variant="outline-primary"
              type="submit"
              className='py-2 px-4'
            >
              <IoDocumentTextOutline size={18} />
              <span className='ps-2'>Report</span>
            </Button>
          </div>
        }
      />
      <div className='p-3 border-top'>
        <div className='row'>
          <div className='col-lg-12'>
            {
              isLoading ?
                <div className='data-loading-container'>
                  <div className='loader'>
                    <div className='spinner' />
                  </div>
                </div>
                :
                <div className='mb-5'>
                  <div className='pb-3'>
                    <Form>
                      <div className='row'>
                        <div className='col-8'>
                          <div className='row'>
                            <div className='col-lg-12 col-md-12 col-12'>
                              <div className='position-relative'>
                                <div className='position-absolute left-0 top-0 bottom-0 ps-3 d-flex align-items-center justify-content-center'>
                                  <IoSearch size={20} color={`var(--bs-placeholder)`} />
                                </div>
                                <Form.Control
                                  type="text"
                                  placeholder="Search by merchant, category, employee or amount"
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                  className='ps-5'
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='col-4 d-flex justify-content-end'>
                          <Button
                            variant="outline-primary"
                            type="button"
                            className='py-2 px-3'
                            onClick={() => setShowCategoryModal(true)}
                          >
                            <IoIosList size={20} />
                            <span className='ps-2'>Categories</span>
                          </Button>
                          <Button
                            variant="primary"
                            type="button"
                            className='py-2 px-3 ms-3'
                            onClick={() => setShowExpenseModal(true)}
                          >
                            <IoAddOutline size={20} />
                            <span className='ps-2'>New Expense</span>
                          </Button>
                        </div>
                      </div>
                    </Form>
                  </div>
                  <Datatable
                    columns={["Date", "Category", "Sub Category", "Payment Mode", "Amount", "Status"]}
                    data={data}
                  />
                </div>
            }
          </div>
        </div>
      </div>



      <Categories showCategoryModal={showCategoryModal} setShowCategoryModal={setShowCategoryModal} />

      <AddUpdateExpense
        showExpenseModal={showExpenseModal}
        setShowExpenseModal={setShowExpenseModal}
      />
    </section>
  );
}

export default Expenses;
